import { dropBoolean } from 'utils/drops';

const getAtividadeEntidadeFilterFields = (drops = {}) => [
  { name: 'id', label: 'ID', type: 'number' },
  { name: 'descricao', label: 'Descrição', initial: true },
  {
    name: 'classe_cnae',
    label: 'Classe CNAE',
    type: 'select',
    options: drops?.ClasseCnae,
    multiple: true,
  },
  { name: 'codigo', label: 'Código' },
  { name: 'ativo', label: 'Ativo', type: 'select', options: dropBoolean },
];

export default getAtividadeEntidadeFilterFields;
